import Model from "~/models/_Model";
import Comparison from "./Comparison";
import Assignment from "./Assignment";

export default class EspSection extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/schoology";
  }

  // Set the resource route of the model
  resource() {
    return "sections";
  }

  primaryKey() {
    return "SECTION_KEY";
  }

  get display_name() {
    if (!this.COURSE) {
      return "Section Not Loaded";
    }
    return (
      this.COURSE.trim() +
      "-" +
      this.COURSE_SECTION +
      ": " +
      this.DESCRIPTION_CLEAN
    );
  }

  get display_marking_periods() {
    if (!this.marking_periods) {
      return "";
    }
    return this.marking_periods
      .map((mp) => mp.MARKING_PERIOD.trim())
      .join(", ");
  }

  get building_name() {
    switch (this.BUILDING) {
      case "100":
      case 100:
        return "East Leyden High School";
      case "200":
      case 200:
        return "West Leyden High School";
      case "300":
      case 300:
        return "LIFE Program";
      default:
        return this.BUILDING;
    }
  }

  get sort_key() {
    return `${this.display_marking_periods}-${this.period}-${this.display_name}`;
  }

  comparisons() {
    return this.hasMany(Comparison);
  }

  assignments() {
    return this.hasMany(Assignment);
  }
}
